import React, { useEffect, useState } from 'react';

import { Container, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import Administrators from '../../components/workspaces/Administrators';
import Filters from '../../components/workspaces/Filters';
import LinkedNamespaces from '../../components/workspaces/LinkedNamespaces';
import PlaceOrderReceivers from '../../components/workspaces/PlaceOrderReceivers';
import Workspaces from '../../components/workspaces/Workspaces';
import { ACTIONS } from '../../constants/logs';
import LogService from '../../services/log.service';
import useBlocRef from '../../utils/useBlocRef.hook';
import InviteAdmin from '../inviteAdmin/InviteAdmin';
import ReinviteAdmin from '../reinviteAdmin/ReinviteAdmin';

export default () => {
  const history = useHistory();
  const [workspaces, setWorkspaces] = useState([]);
  const [workspacesCount, setWorkspacesCount] = useState(0);
  const [adminsCount, seAdminsCount] = useState(0);
  const [ambraNamespaces, setAmbraNamespaces] = useState([]);
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const [discounts, setDiscounts] = useState([]);
  const [admins, setAdmins] = useState([]);
  const blocRef = useBlocRef('workspacesBloc');

  useEffect(() => {
    const workspacesSub = blocRef.current.workSpaces$.subscribe(setWorkspaces);
    const adminsSub = blocRef.current.administrators$.subscribe(setAdmins);
    const selectedWorkspaceSub = blocRef.current.selectedWorkspace$.subscribe(setSelectedWorkspace);
    const workspacesCountSub = blocRef.current.workspacesCount$.subscribe(setWorkspacesCount);
    const adminsCountSub = blocRef.current.adminsCount$.subscribe(seAdminsCount);
    const ambraNamespacesSub = blocRef.current.ambraNamespaces$.subscribe(setAmbraNamespaces);
    const discountsSub = blocRef.current.discounts$.subscribe(setDiscounts);

    blocRef.current.getAmbraNamespaces();
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      blocRef.current.dispose();
      workspacesSub.unsubscribe();
      adminsSub.unsubscribe();
      selectedWorkspaceSub.unsubscribe();
      workspacesCountSub.unsubscribe();
      adminsCountSub.unsubscribe();
      ambraNamespacesSub.unsubscribe();
      discountsSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    new LogService().create({
      action: ACTIONS.WORKSPACE_SEARCH,
      details: {
        Amount: 10,
        Page: 1,
      },
    });
  }, []);

  const handleAddAdmin = () => {
    blocRef.current.addAdmin(() => <InviteAdmin workspaceId={selectedWorkspace.id} onUpdateAdmins={() => blocRef.current.updateAdminSearchCriteria()} />);
  };

  const handleInviteAdmin = (admin) => {
    blocRef.current.resendInvite(admin, () => <ReinviteAdmin workspaceId={selectedWorkspace.id} onUpdateAdmins={() => blocRef.current.updateAdminSearchCriteria()} />);
  };

  const handleCreateWorkspace = () => {
    history.push('/new-workspace');
  };

  const handleSelectWorkspace = (id) => {
    const currentWorkspaces = blocRef.current.currentWorkspaces();

    if (!currentWorkspaces) return;

    const workspace = currentWorkspaces.find((item) => id === item.id);

    if (workspace) {
      blocRef.current.setWorkspace(workspace);

      new LogService().create({
        action: ACTIONS.WORKSPACE_VIEW,
        details: {
          Workspace: workspace.name,
          'Workspace ID': workspace.id,
        },
      });
    }
  };

  const handleWorkspaceCriteriaChange = (updatedCriteria) => {
    blocRef.current.updateSearchCriteria(updatedCriteria);

    new LogService().create({
      action: ACTIONS.WORKSPACE_SEARCH,
      details: {
        Amount: updatedCriteria?.limit || 10,
        Keyword: updatedCriteria?.keyword || '',
        Page: updatedCriteria?.page + 1,
      },
    });
  };

  const handleAdminsCriteriaChange = (updatedCriteria) => {
    blocRef.current.updateAdminSearchCriteria(updatedCriteria);
  };

  const handleCanRequestBeforePayClick = (workspaceId, isAllowed) => {
    blocRef.current.updateCanRequestBeforePay(workspaceId, isAllowed);
  };

  const handleCreatorModeChange = (workspaceId, isActive) => {
    blocRef.current.updateCreatorMode(workspaceId, isActive);
  };

  const handleUpdateDiscount = (workspaceId, discountId) => {
    blocRef.current.updateWorkspaceDiscount(workspaceId, discountId);
  };

  const handleSaveNamespaces = async (workspaceId, namespaceIds) => {
    await blocRef.current.updateLinkedNamespaces(workspaceId, namespaceIds);
  };

  const handleUserClick = ({ userId, status }) => {
    blocRef.current.openUserRoleChangeDialog({ status, userId });
  };

  const handleUpdateLandingUrl = (workspaceId, landingUrl) => {
    blocRef.current.updateWorkspaceLandingUrl(workspaceId, landingUrl);
  };

  const handleUpdateSubdomain = (workspaceId, subdomain) => {
    blocRef.current.updateWorkspaceSubdomain(workspaceId, subdomain);
  };

  const handleUpdateMainFileType = (workspaceId, mainFileType) => {
    blocRef.current.updateWorkspaceMainFileType(workspaceId, mainFileType);
  };

  const handleUpdateRadiologyReportRequired = (workspaceId, radiologyReportRequired) => {
    blocRef.current.updateWorkspaceRadiologyReportRequired(workspaceId, radiologyReportRequired);
  };

  const handleSendPlacedOrdersToAdminsChange = (workspaceId, sendPlacedOrdersToAdmins) => {
    blocRef.current.updateWorkspaceSendPlacedOrdersToAdmins(workspaceId, sendPlacedOrdersToAdmins);
  };

  const handleSaveEmailsForPlacedOrders = (emails) => {
    blocRef.current.updateWorkspaceEmailsForPlacedOrders(selectedWorkspace.id, emails);
  };

  return (
    <Grid container component={Container}>
      <Grid item xs={12}>
        <Filters onCriteriaChange={handleWorkspaceCriteriaChange} onCreateWorkspace={handleCreateWorkspace} />
      </Grid>
      <Grid item container xs={12}>
        <Grid item xs={6}>
          <Workspaces onCriteriaChange={handleWorkspaceCriteriaChange} onWorkspaceClick={handleSelectWorkspace} workspaces={workspaces} total={workspacesCount} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: '20px' }}>
          <Administrators
            onCriteriaChange={handleAdminsCriteriaChange}
            workspace={selectedWorkspace}
            workspaceName={selectedWorkspace ? selectedWorkspace.name : ''}
            workspaceId={selectedWorkspace ? selectedWorkspace.id : ''}
            workspaceClinicCode={selectedWorkspace?.clinicCode || ''}
            workspaceAllowClinicUpload={selectedWorkspace?.allowClinicUpload || false}
            canRequestBeforePay={selectedWorkspace?.canRequestBeforePay || false}
            workspaceCreatorMode={selectedWorkspace?.creatorMode || false}
            workspaceDiscount={selectedWorkspace?.discount || ''}
            onAddAdmin={handleAddAdmin}
            onInvitedClick={handleInviteAdmin}
            onCanRequestBeforePayClick={handleCanRequestBeforePayClick}
            onCreatorModeChange={handleCreatorModeChange}
            onUpdateDiscount={handleUpdateDiscount}
            onUserClick={handleUserClick}
            discounts={discounts}
            admins={admins}
            total={adminsCount}
            onUpdateSubdomain={handleUpdateSubdomain}
            onUpdateLandingUrl={handleUpdateLandingUrl}
            workspaceSubdomain={selectedWorkspace?.subdomain || ''}
            workspaceLandingUrl={selectedWorkspace?.landingUrl || ''}
            isMediphanyWorkspace={selectedWorkspace?.isMediphanyWorkspace}
            mainFileType={selectedWorkspace?.mainFileType}
            workspaceRadiologyReportRequired={selectedWorkspace?.radiologyReportRequired}
            sendPlacedOrdersToAdmins={selectedWorkspace?.sendPlacedOrdersToAdmins}
            onUpdateRadiologyReportRequiredChange={handleUpdateRadiologyReportRequired}
            onSendPlacedOrdersToAdminsChange={handleSendPlacedOrdersToAdminsChange}
            onRadiologyReportRequiredChange={handleUpdateRadiologyReportRequired}
            onUpdateMainFileType={handleUpdateMainFileType}
          />

          <PlaceOrderReceivers emailsForPlacedOrders={selectedWorkspace?.emailsForPlacedOrders} onSaveEmailsForPlacedOrders={handleSaveEmailsForPlacedOrders} />

          <LinkedNamespaces
            isUpdating$={blocRef.current.isUpdatingNamespaces$}
            ambraNamespaces={ambraNamespaces}
            selectedWorkspace={selectedWorkspace}
            onSaveNamespaces={handleSaveNamespaces}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
